import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { observer } from 'mobx-react'
import Types from 'app/React/ProductForm/Types'
import VariationsTypeHeading from 'app/React/ProductForm/VariationsTypeHeading'
import VariationsTypeTooltip from 'app/React/ProductForm/VariationsTypeTooltip'

function TypePicker() {
  const [types] = useEnvValue('types', null)
  const [selectedType, setSelectedType] = useEnvValue('selectedType', null)

  if (types === null || types.length < 1) return null

  const updateSelectedVariationInEnv = function (typeKey) {
    setSelectedType(typeKey)
  }

  const onChange = function (e) {
    updateSelectedVariationInEnv(e.target.value)
  }

  return (
    <section className="mtt-variations mtt-variations--no-margin" data-attribute="type">
      <div className="variations-heading">
        <VariationsTypeHeading/>
        <VariationsTypeTooltip/>
      </div>
      <Types onChange={onChange}/>
    </section>
  )
}

export default observer(TypePicker)
